// extracted by mini-css-extract-plugin
export default {"Spinner":"kkhsd2mS","spin":"iZb3XNsK"};